import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { plataformaApi } from '@/lib/api/plataforma';
import { useSessaoDeOperador } from './sessaoDeOperador';

/**
 * Entrada do console da plataforma.
 *
 * Tela separada do login de gabinete porque a sessão é de outra natureza, e
 * porque quem opera a plataforma não deve tropeçar nela sem querer: a rota é
 * `/plataforma`, não aparece em menu nenhum do produto.
 */
export function LoginOperadorPage() {
  const navigate = useNavigate();
  const entrar = useSessaoDeOperador((s) => s.entrar);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function submeter(e: React.FormEvent) {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      const r = await plataformaApi.login(email, senha);
      entrar(r.token, r.operador);
      navigate('/plataforma/mandatos');
    } catch (err: any) {
      setErro(err?.response?.data?.message ?? 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login">
      <div className="l">
        <span className="wordmark">Eleg360</span>
        <h1>Console da plataforma</h1>
        <p>Cadastro de mandatos e dos seus titulares. Área restrita à operação.</p>
      </div>
      <div className="r">
        <form onSubmit={submeter}>
          <h2>Entrar como operador</h2>

          <label className="field">
            E-mail
            <input
              className="in"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </label>

          <label className="field">
            Senha
            <input
              className="in"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          {!!erro && (
            <div className="note crit" role="alert">
              {erro}
            </div>
          )}

          <button className="btn pri" type="submit" disabled={enviando}>
            {enviando ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
